import React, {useCallback, useMemo} from 'react';
import assert from 'assert-ts';
import {
  Layout,
  ResponsiveLayout,
  ResponsiveLayoutStyles,
  Snackbar,
} from '@di-nxt/components';
import {query} from '@di-nxt/query';
import {useSnacks, useSnacksActions} from '../../services';

export const Snacks: React.FC = () => {
  const snacks = useSnacks();
  const sortedSnacks = useMemo(
    () => query(snacks).orderBy('timestamp').toArray(),
    [snacks],
  );

  const {remove} = useSnacksActions();

  const handleDismiss = useCallback(
    (id: string | number | undefined) => {
      const snackId = assert(id) as string;
      remove(snackId);
    },
    [remove],
  );

  return sortedSnacks.length > 0 ? (
    <Layout
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={1000}
      pointerEvents="none">
      <Layout paddingBottom="20" align="flex-end" justify="center" flex>
        <ResponsiveLayout styles={responsiveStyle}>
          <Layout vertical spacing="16" flex pointerEvents="box-none">
            {sortedSnacks.map(s => (
              <Snackbar
                key={s.id}
                id={s.id}
                content={s.text}
                kind={s.status}
                onDismiss={handleDismiss}
                hasCloseButton
                duration={5000}
              />
            ))}
          </Layout>
        </ResponsiveLayout>
      </Layout>
    </Layout>
  ) : null;
};

const responsiveStyle: ResponsiveLayoutStyles = {
  desktop: {
    width: '480px',
  },
  tablet: {
    width: '374px',
  },
  mobile: {
    flex: 1,
    paddingHorizontal: '20',
  },
};
